import React from 'react';
import classnames from 'classnames';
import { bemHelper, pure } from '@dbk/ui-react-utils';
import AccordionBody from './custom-accordion-body';
import AccordionTitle from './custom-accordion-title';
import {
  accordionItemDefaultProps,
  accordionItemPropTypes,
} from './custom-accordion-common';

import styles from './custom-accordion.css';

const bem = bemHelper(styles, 'custom_accordion', 'item');

const AccordionItem = (props) => {
  const {
    renderTitle,
    handleChange,
    itemKey,
    children,
    className,
    active,
    disabled,
    fullWidth,
    renderIconForOpen,
    renderIconForClose,
    iconPosition,
    ...other
  } = props;

  const classNames = classnames(bem(), className, {
    [bem(null, 'active')]: active,
    [bem(null, 'disabled')]: disabled,
    [bem(null, 'full-width')]: fullWidth,
  });

  const icon = active ? renderIconForOpen : renderIconForClose;
  const handleClick = () => {
    if (!disabled) {
      handleChange(itemKey);
    }
  };

  return (
    <div className={classNames} {...other}>
      <AccordionTitle
        renderTitle={renderTitle}
        renderIcon={icon}
        onClick={handleClick}
        fullWidth={fullWidth}
        itemKey={itemKey}
        iconPosition={iconPosition}
      />
      <AccordionBody fullWidth={fullWidth}>{children}</AccordionBody>
    </div>
  );
};

AccordionItem.defaultProps = accordionItemDefaultProps;
AccordionItem.propTypes = accordionItemPropTypes;

export default pure(AccordionItem);
